/*
 * @Author: chillylight
 * @Date:   2020-04-20 14:56:00
 * @Last Modified by:   chillylight
 * @Last Modified time: 2020-09-30 10:09:06
 */
import "@src/assets/css/swiper.min.css";
import Swiper from "@src/assets/js/swiper.min.js";
import _activity from "@src/assets/js/server/activity-server";
import _notice from "@src/assets/js/server/notice-server";
import _comMeds from "@src/assets/js/common.js";

var page = {
  data: {
    lunboUrl: '',
    jumpStatus: 0,
    openType: 0
  },
  init() {
    this.onLoad();
    this.bindEvent();
  },
  onLoad() {
    this.getscreen();
  },
  bindEvent() {
    let _this = this
    $("body").on('click','.swiper-slide img.banner2.can-click', function (e) {
      _comMeds.countLink(159);
      // let url = res.url + `?banner_id=${res.id}&pageFrom_b=3`
      let url = _this.data.lunboUrl
      if (_this.data.jumpStatus !== 0) {
        if(_this.data.openType === 1){
          window.location.href = url
        } else {
          window.open(url, "_blank");
        }
      }
    });
  },
  // banner轮播
  toggleBanner() {
    let count = 0;
    var mySwiper = new Swiper(".swiper-container", {
      pagination: {
        el: ".swiper-pagination-banner",
        clickable: true,
      },
      paginationType: "bullets",
      effect: "fade",
      loop: true,
      speed: 2000,
      observer: true,
      observeParents: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false, //防止手动滑动后不自动滑动
      },
    });
    let target_timestring = Date.parse(new Date("2022/12/30"));
    let now_timestring = new Date().getTime();
    if (target_timestring < now_timestring) {
      let para = {
        activityId: 102,
      };
      _activity.decideActivityTime(para, function (res) {
        count++;
        let inviteImg = require("../../assets/images/activity/newyear/trans_banner.png");
        let swiperList = [
          `<div class="swiper-slide">
								<img src="${inviteImg}" alt="元旦打卡活动活动" class="lunbo-img banner2 can-click">
								</div>`,
        ];
        mySwiper.addSlide(0, swiperList);
        setTimeout(mySwiper.slideTo(1, 0, false), 100);
        mySwiper.update(true);
        mySwiper.autoplay.start();
        $(".swiper-pagination-banner").show();
      });
    }

    _activity.geActivityInfo(
      {},
      function (res) {
        count++;
        var img1 = require("../../assets/images/activity/oct/baoming_1.png");
        var img2 = require("../../assets/images/activity/oct/baoming_2.png");
        var img3 = require("../../assets/images/activity/oct/baoming_3.png");
        var img4 = require("../../assets/images/activity/oct/baoming_4.png");
        var img5 = require("../../assets/images/activity/oct/baoming_5.png");
        var img6 = require("../../assets/images/activity/oct/baoming_6.png");
        var str = "";

        if (res.activitystatus == "2") {
          sessionStorage.setItem("actIsPause", 1);
        } else {
          sessionStorage.setItem("actIsPause", 0);
        }
        // 存储是哪个阶段的活动
        if (res.stage) {
          sessionStorage.setItem("whichStep", res.stage);
        }

        // 1号到3号，活动在进行中
        if (res.stage == "1") {
          if (res.activitystatus == "0") {
            str = [
              `<div class="swiper-slide">
            			<img src="${img1}" alt="国庆活动" class="lunbo-img">
            			</div> `,
            ];
          } else if (res.activitystatus == "2") {
            str = [
              `<div class="swiper-slide">
            			<img src="${img2}" alt="国庆活动" class="lunbo-img">
            			</div> `,
            ];
          }
        }
        // 4号到9号
        if (res.stage == "2") {
          if (res.activitystatus == "0") {
            str = [
              `<div class="swiper-slide">
            			<img src="${img3}" alt="国庆活动" class="lunbo-img">
            			</div> `,
            ];
          }
          if (res.activitystatus == "2") {
            str = [
              `<div class="swiper-slide">
            			<img src="${img4}" alt="国庆活动" class="lunbo-img">
            			</div> `,
            ];
          }
        }
        // 9到30号
        if (res.stage == "3") {
          if (res.activitystatus == "0") {
            str = [
              `<div class="swiper-slide">
            			<img src="${img5}" alt="国庆活动" class="lunbo-img">
            			</div> `,
            ];
          }
          if (res.activitystatus == "2") {
            str = [
              `<div class="swiper-slide">
            			<img src="${img6}" alt="国庆活动" class="lunbo-img">
            			</div> `,
            ];
          }
        }

        if (count == "1") {
          mySwiper.addSlide(0, str);
        } else {
          mySwiper.addSlide(1, str);
        }

        setTimeout(mySwiper.slideTo(1, 0, false), 100);
        mySwiper.update(true);
        mySwiper.autoplay.start();
      },
      function (res) {}
    );
  },

  // 立即翻译广告位
  getscreen() {
    // var params = {
    //   number: "5",
    //   height: "0",
    // };
    // _notice.getscreen(
    //   params,
    //   function (res) {
    //     if (res) {
    //       $(".swiper-slide img.banner1").hide();
    //       $(".swiper-slide img.banner2").show();
    //       $(".swiper-slide img.banner2").attr("src", res.image);
    //       $(".swiper-slide img.banner2").click(function(e){
    //         _comMeds.countLink(392);
    //       });
    //       _comMeds.countLink(158);
    //       if (
    //         res.url == null ||
    //         res.url == "" ||
    //         res.url == undefined ||
    //         res.url == "0"
    //       ) {
    //       } else {
    //         $("body").on("click", ".swiper-slide img.banner2", function (e) {
    //           var tempwindow = window.open("", "_blank");
    //           tempwindow.location = _comMeds.urlFilter(res.url);
    //           // window.open( res.url,"_blank");
    //           _comMeds.countLink(159);
    //           _comMeds.countLink(392);
    //         });
    //       }
    //     }
    //   },
    //   function (res) {
    //     if (res.code == "-5000901") {
    //       // 202107vip拉新 7.1-7.10
    //       let time_now = new Date().getTime();
    //       let time_b = new Date("2021/07/01").getTime();
    //       let time_e = new Date("2021/07/11").getTime();
    //       $(".swiper-slide img.banner2").hide();
    //       if (time_now >= time_b && time_now <= time_e) {
    //         $(".swiper-slide img.banner1").hide();
    //         $(".swiper-slide img.banner2").show();
    //       }
    //       $("body").on("click", ".swiper-slide img.banner1", function (e) {
    //         // window.open(winPubPath + "/commonWeal.html", "_blank");
    //       });
    //       $("body").on("click", ".swiper-slide img.banner2", function (e) {
    //         _comMeds.countLink(134, 67);
    //         window.open(winPubPath + "/activity/invitation.html", "_blank");
    //       });
    //     }
    //   }
    // );
    let _this = this
    _notice.getAdverWeb({ type: 2, site: 2 }, function (res) {
      // 2.8内容管理 - 获取广告位
      _comMeds.countLink(158);
      if(res.image != ''){
        _this.toggleBanner();
        $(".swiper-slide img.banner2").attr("src", res.image);
        console.log('res', res);
        _this.data.lunboUrl = res.url
        _this.data.jumpStatus = res.jumpStatus
        _this.data.openType = res.openType
        $('.heart-banner .swiper-container').show()
      } else {
        $('.heart-banner .swiper-container').hide()
      }
    });
  },
};

$(function () {
  page.init();
});
